import { useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import BMIModal from ".";

export default function BMIModalExamples() {
  const [controlledOpen, setControlledOpen] = useState(false);

  return (
    <Stack spacing={3}>
      <Box>
        <BMIModal />
      </Box>
      <Box>
        <Button
          variant="outlined"
          onClick={() => setControlledOpen(true)}
          aria-label="Open BMI modal"
        >
          Open modal (controlled)
        </Button>
        <BMIModal
          isOpen={controlledOpen}
          onClose={() => setControlledOpen(false)}
        />
      </Box>
    </Stack>
  );
}
